/// <reference path="../app.ts" />
namespace Cfnc {
    "use strict";

    interface IFileUploadModalScope extends ng.IScope {
        close: () => void;
        upload: () => void;
        data: IData;
        file: any;
    }

    interface IFileUploadModal {
        
    }

    interface IData { type: string; id: number; }

    class FileUploadModal implements IFileUploadModal{
        static controllerId: string = "fileUploadModal";
        private log;
        constructor(private $uibModalInstance: ng.ui.bootstrap.IModalServiceInstance, private common: ICommonFactory, private $scope: IFileUploadModalScope, private $resource: ng.resource.IResourceService, data: IData, private $upload, private config: IConfig) {
            this.log = common.logger.getLogFn(FileUploadModal.controllerId);
            $scope.close = () => this.close();
            $scope.upload = () => this.upload();
            $scope.data = data;
        }

        close() {
            this.$uibModalInstance.dismiss();
             
         }

         upload() {
             this.$upload.upload({
                 url: this.config.apiHost + "/application/" + this.$scope.data.id + "/attachment",
                 method: "POST",
                 file: this.$scope.file
            });
             console.log(this.$scope.data);
        }

        
    }

    angular.module("app").controller(FileUploadModal.controllerId, ["$uibModalInstance", "common", "$scope", "$resource", "data", "$upload", "config", ($uibModalInstance: ng.ui.bootstrap.IModalServiceInstance, common: ICommonFactory, $scope, $resource, data: IData, $upload, config: IConfig) =>
        new FileUploadModal($uibModalInstance, common, $scope, $resource, data, $upload, config)
    ]);
}
